import { Card, CardTitle, Loader, Select, Button, useTranslations } from '@develos/next-components'
import { useFetch } from '@develos/next-library';
import React, { useEffect } from 'react'
import { CameraStream } from '../types';

interface StreamSelectProps {
    metricLocalizationId?: string;
    selectedStreamId?: string;
    activeStreamId?: string;
    streamIsLoading: boolean;

    handleStreamSelected: (stream?: CameraStream) => void;
    handleStartStream: () => void;
    handleStopStream: () => void
}

const StreamSelector = ({
    metricLocalizationId,
    selectedStreamId,
    activeStreamId,
    streamIsLoading,
    handleStreamSelected,
    handleStartStream,
    handleStopStream }: StreamSelectProps) => {

    const { translate } = useTranslations();
    const { get } = useFetch();
    const { data: streams, isLoading, } = get<CameraStream[]>(`LiveCameraPreview/GetAvailableCameraStreams?localizationUid=${metricLocalizationId}`, {enabled: metricLocalizationId != undefined})

    useEffect(() => {
        if (!streams || streams.length === 0) return;

        handleStreamSelected(streams[0])
    }, [streams])


    return (
        <Card className='p-4'>
            <CardTitle title={translate('Dostępne kamery')} />

            {isLoading && <Loader isAbsolute />}

            {streams && streams.length > 0
                ? (
                    <Select
                        disabled={streamIsLoading}
                        options={streams.map(stream => ({
                            label: stream.label,
                            value: stream.uId,
                            isDisabled: selectedStreamId === stream.uId
                        }))}

                        value={selectedStreamId}
                        handleChange={(_, value) => handleStreamSelected(streams.find(x => x.uId == value))}
                    />
                )

                : (
                    <p>Brak dostępnych kamer w wybranej lokalizacji</p>
                )}


            <div className='rm-flex rm-flex-col rm-mt-4 md:rm-flex-row md:rm-justify-between'>
                <Button
                    disabled={isLoading || streamIsLoading}
                    handleClick={handleStartStream}>
                    {streamIsLoading
                        ? translate('Trwa nawiązywanie połączenia...')
                        : translate('Nawiąż połaczenie z kamerą')}
                </Button>

                <Button
                    variant='red'
                    disabled={isLoading || streamIsLoading || !activeStreamId}
                    handleClick={handleStopStream}>
                    {translate('Przerwij połączenie z kamerą')}
                </Button>
            </div>
        </Card>
    )
}

export default StreamSelector